export default __webpack_public_path__ + "static/plan-anytime-mobile-6bdd5eeb4083db4d1e66f9d51f7acbbf.svg";